import React, {useEffect, useState} from "react";
import {goVehisService} from "../../../utils/axios";

const NET_FINANCING_TYPES = ["LEASING_BUSINESS", "LEASING_LOAN"];

function VehicleGapCheckbox({vehicleId, financingType, financingMonths, checked, onChange, onDataLoaded, showFallback}) {

    const [gapData, setGapData] = useState(undefined);

    useEffect(() => {
        if (!financingType || !financingMonths) return;

        setGapData(undefined);

        goVehisService(`/vehicles/${vehicleId}/gap`, {
            params: {financingType, financingMonths}
        })
            .then(response => {
                setGapData(response.data);
                if (onDataLoaded) onDataLoaded(response.data);
            })
            .catch(() => {
                setGapData(null);
                if (onDataLoaded) onDataLoaded(null);
            });
    }, [vehicleId, financingType, financingMonths]);

    if (gapData === undefined) return null;
    if (gapData === null && !showFallback) return null;

    const isNet = NET_FINANCING_TYPES.includes(financingType);
    const suffix = isNet ? "netto" : "brutto";
    const oneTimePremium = gapData?.oneTimePremium;
    const priceText = oneTimePremium != null
        ? oneTimePremium.toLocaleString('pl-PL') + " zł " + suffix
        : "indywidualna wycena";

    return (
        <div className="calc__form-item">
            <label className="search-checkbox-row calc__ins-row calc__ins-row--ocac">
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={onChange}
                    className="calc__insurance-ocac-input"
                />
                <span className="calc__ins-label">GAP na czas trwania umowy</span>
                <span className={"calc__ins-price" + (oneTimePremium == null ? " calc__insurance-individual" : "")}>
                    {priceText}
                </span>
            </label>
        </div>
    );
}

export default VehicleGapCheckbox;
